import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState, useEffect, useRef } from "react";
import { Button, useEditorContext, cn, UnStyledButton, CloseIcon, Tooltip, PenIcon, StarFilledIcon, StarIcon, TrashIcon } from "@graphiql/react";
import { useHistory, useHistoryActions } from "./context.js";
function handleDelete(items, deleteFromHistory) {
  for (const item of items) {
    deleteFromHistory(item, true);
  }
}
const History = () => {
  const $ = c(13);
  const all = useHistory();
  const {
    deleteFromHistory
  } = useHistoryActions();
  let items;
  items = all.slice().map(_temp).reverse();
  const favorites = items.filter(_temp2);
  if (favorites.length) {
    items = items.filter(_temp3);
  }
  const [clearStatus, setClearStatus] = useState(null);
  let t0;
  let t1;
  if ($[0] !== clearStatus) {
    t0 = () => {
      if (clearStatus) {
        setTimeout(() => {
          setClearStatus(null);
        }, 2e3);
      }
    };
    t1 = [clearStatus];
    $[0] = clearStatus;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const handleClearStatus = () => {
    try {
      handleDelete(items, deleteFromHistory);
      setClearStatus("success");
    } catch {
      setClearStatus("error");
    }
  };
  const hasFavorites = Boolean(favorites.length);
  const hasItems = Boolean(items.length);
  const t2 = "History";
  const t3 = "graphiql-history";
  const t4 = (clearStatus || hasItems) && /* @__PURE__ */ jsx(Button, { type: "button", state: clearStatus || void 0, disabled: !items.length, onClick: handleClearStatus, children: {
    success: "Cleared",
    error: "Failed to Clear"
  }[clearStatus] || "Clear" });
  let t5;
  if ($[3] !== t4) {
    t5 = /* @__PURE__ */ jsxs("div", { className: "graphiql-history-header", children: [
      "History",
      t4
    ] });
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = hasFavorites && /* @__PURE__ */ jsx("ul", { className: "graphiql-history-items", children: favorites.map(_temp4) });
  let t7;
  if ($[5] !== hasFavorites || $[6] !== hasItems) {
    t7 = hasFavorites && hasItems && /* @__PURE__ */ jsx("div", { className: "graphiql-history-item-spacer" });
    $[5] = hasFavorites;
    $[6] = hasItems;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = hasItems && /* @__PURE__ */ jsx("ul", { className: "graphiql-history-items", children: items.map(_temp5) });
  let t9;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8) {
    t9 = /* @__PURE__ */ jsxs("section", { "aria-label": t2, className: t3, children: [
      t5,
      t6,
      t7,
      t8
    ] });
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
const HistoryItem = (props) => {
  const $ = c(39);
  const {
    editLabel,
    toggleFavorite,
    deleteFromHistory,
    setActive
  } = useHistoryActions();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      nonNull: true,
      caller: HistoryItem
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    headerEditor,
    queryEditor,
    variableEditor
  } = useEditorContext(t0);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const [isEditable, setIsEditable] = useState(false);
  let t1;
  let t2;
  if ($[1] !== isEditable) {
    t1 = () => {
      var _a;
      if (isEditable) {
        (_a = inputRef.current) == null ? void 0 : _a.focus();
      }
    };
    t2 = [isEditable];
    $[1] = isEditable;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== props.item.label || $[5] !== props.item.operationName || $[6] !== props.item.query) {
    t3 = props.item.label || props.item.operationName || formatQuery(props.item.query);
    $[4] = props.item.label;
    $[5] = props.item.operationName;
    $[6] = props.item.query;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const displayName = t3;
  let t4;
  if ($[8] !== editLabel || $[9] !== props.item) {
    t4 = () => {
      var _a;
      setIsEditable(false);
      const {
        index,
        ...item
      } = props.item;
      editLabel({
        ...item,
        label: (_a = inputRef.current) == null ? void 0 : _a.value
      }, index);
    };
    $[8] = editLabel;
    $[9] = props.item;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleSave = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsEditable(false);
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleClose = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = (e) => {
      e.stopPropagation();
      setIsEditable(true);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleEditLabel = t6;
  let t7;
  if ($[13] !== headerEditor || $[14] !== props.item || $[15] !== queryEditor || $[16] !== setActive || $[17] !== variableEditor) {
    t7 = () => {
      const {
        query,
        variables,
        headers
      } = props.item;
      queryEditor == null ? void 0 : queryEditor.setValue(query ?? "");
      variableEditor == null ? void 0 : variableEditor.setValue(variables ?? "");
      headerEditor == null ? void 0 : headerEditor.setValue(headers ?? "");
      setActive(props.item);
    };
    $[13] = headerEditor;
    $[14] = props.item;
    $[15] = queryEditor;
    $[16] = setActive;
    $[17] = variableEditor;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleHistoryItemClick = t7;
  let t8;
  if ($[19] !== deleteFromHistory || $[20] !== props.item) {
    t8 = (e_0) => {
      e_0.stopPropagation();
      deleteFromHistory(props.item);
    };
    $[19] = deleteFromHistory;
    $[20] = props.item;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const handleDeleteItemFromHistory = t8;
  let t9;
  if ($[22] !== props.item || $[23] !== toggleFavorite) {
    t9 = (e_1) => {
      e_1.stopPropagation();
      toggleFavorite(props.item);
    };
    $[22] = props.item;
    $[23] = toggleFavorite;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const handleToggleFavorite = t9;
  const t10 = isEditable && "editable";
  let t11;
  if ($[25] !== t10) {
    t11 = cn("graphiql-history-item", t10);
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== displayName || $[28] !== editLabel || $[29] !== handleDeleteItemFromHistory || $[30] !== handleHistoryItemClick || $[31] !== handleSave || $[32] !== handleToggleFavorite || $[33] !== isEditable || $[34] !== props.item) {
    t12 = isEditable ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("input", { type: "text", defaultValue: props.item.label, ref: inputRef, onKeyDown: (e_2) => {
        if (e_2.key === "Esc") {
          setIsEditable(false);
        } else {
          if (e_2.key === "Enter") {
            setIsEditable(false);
            editLabel({
              ...props.item,
              label: e_2.currentTarget.value
            });
          }
        }
      }, placeholder: "Type a label" }),
      /* @__PURE__ */ jsx(UnStyledButton, { type: "button", ref: buttonRef, onClick: handleSave, children: "Save" }),
      /* @__PURE__ */ jsx(UnStyledButton, { type: "button", ref: buttonRef, onClick: handleClose, children: /* @__PURE__ */ jsx(CloseIcon, {}) })
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Tooltip, { label: "Set active", children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-history-item-label", onClick: handleHistoryItemClick, "aria-label": "Set active", children: displayName }) }),
      /* @__PURE__ */ jsx(Tooltip, { label: "Edit label", children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-history-item-action", onClick: handleEditLabel, "aria-label": "Edit label", children: /* @__PURE__ */ jsx(PenIcon, { "aria-hidden": "true" }) }) }),
      /* @__PURE__ */ jsx(Tooltip, { label: props.item.favorite ? "Remove favorite" : "Add favorite", children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-history-item-action", onClick: handleToggleFavorite, "aria-label": props.item.favorite ? "Remove favorite" : "Add favorite", children: props.item.favorite ? /* @__PURE__ */ jsx(StarFilledIcon, { "aria-hidden": "true" }) : /* @__PURE__ */ jsx(StarIcon, { "aria-hidden": "true" }) }) }),
      /* @__PURE__ */ jsx(Tooltip, { label: "Delete from history", children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-history-item-action", onClick: handleDeleteItemFromHistory, "aria-label": "Delete from history", children: /* @__PURE__ */ jsx(TrashIcon, { "aria-hidden": "true" }) }) })
    ] });
    $[27] = displayName;
    $[28] = editLabel;
    $[29] = handleDeleteItemFromHistory;
    $[30] = handleHistoryItemClick;
    $[31] = handleSave;
    $[32] = handleToggleFavorite;
    $[33] = isEditable;
    $[34] = props.item;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t11 || $[37] !== t12) {
    t13 = /* @__PURE__ */ jsx("li", { className: t11, children: t12 });
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};
function formatQuery(query) {
  return query == null ? void 0 : query.split("\n").map((line) => line.replace(/#(.*)/, "")).join(" ").replaceAll("{", " { ").replaceAll("}", " } ").replaceAll(/[\s]{2,}/g, " ");
}
function _temp(item, i) {
  return {
    ...item,
    index: i
  };
}
function _temp2(item_0) {
  return item_0.favorite;
}
function _temp3(item_1) {
  return !item_1.favorite;
}
function _temp4(item_2) {
  return /* @__PURE__ */ jsx(HistoryItem, { item: item_2 }, item_2.index);
}
function _temp5(item_3) {
  return /* @__PURE__ */ jsx(HistoryItem, { item: item_3 }, item_3.index);
}
export {
  History,
  HistoryItem,
  formatQuery
};
//# sourceMappingURL=components.js.map
